import {
  FormDescriptor,
  GroupZoneDescriptor,
  GroupZoneType,
  TabSheetDescriptor,
  ZoneDescriptor
} from './form-generator.interfaces';

export class FormGeneratorUtils {

    public static sanitizeZoneName(zoneName: string): string {
        if (!zoneName) {
            return zoneName;
        }
        return zoneName.replace('.', '§');
    }

    public static simplifyZoneName(zoneName: string): string {
        if (!zoneName) {
            return zoneName;
        }
        return zoneName.split('_')[0];
    }

    public static isFileZoneExist(descriptor: FormDescriptor): boolean {
        return descriptor.tabSheets.some((tabSheet: TabSheetDescriptor) => {
            return tabSheet.groupZones.some((groupZone: GroupZoneDescriptor) => {
                return groupZone.zones.some((zone: ZoneDescriptor) => zone.type === 'FILE');
            });
        });
    }

    public static AddAttachemtsTabEmpty(tabSheets: TabSheetDescriptor[]) {
        tabSheets.push({
            tabSheetID: 'Attachments',
            tabSheetPosition: 1003,
            transId: 'EMPLOYEE_MANAGE.attachments',
            groupZones: [],
            translate: ''
        });
    }

    public static addAttachmentsTab(tabSheets: TabSheetDescriptor[]) {
        tabSheets.push({
            tabSheetID: 'Attachments',
            tabSheetPosition: 1003,
            transId: 'EMPLOYEE_MANAGE.attachments',
            groupZones: [
                {
                    groupZoneID: 'Attachments',
                    transId: 'EMPLOYEE_MANAGE.attachments',
                    groupZoneType: GroupZoneType.UNIQUE_NON_MANDATORY,
                    internalType: 'NONE',
                    displayorder: 100,
                    metadatas: {},
                    isDated: true,
                    nbCol: 4,
                    readOnly: false,
                    zones: []
                }
            ],
            translate: ''
        });
    }
}
